// extracted by mini-css-extract-plugin
module.exports = {"skip-links":"styles_skip-links__eqJw8","skip-links__anchor":"styles_skip-links__anchor__3hbIN"};